import type { RouteMeta } from 'vue-router';

import { adminEnumRoutes } from '@/routes/admin/admin.enum.routes';

export const AdminMenuItems: {
  path: string;
  name: string;
  meta: RouteMeta;
}[] = [
  // Internal Training first: it is the default landing when the
  // `internal-team-mode` org flag is enabled (see auth.checkAdminPermission
  // for the explicit landing switch). With the flag off the item is filtered
  // out by its config gate and the legacy dashboard stays the landing.
  adminEnumRoutes.internalTeam,
  adminEnumRoutes.dashboard,
  adminEnumRoutes.users,
  adminEnumRoutes.teams,
  adminEnumRoutes.journeys,
  adminEnumRoutes.courses,
  adminEnumRoutes.LearningCategories,
  adminEnumRoutes.registrationRequest,
  adminEnumRoutes.approvals,
  adminEnumRoutes.grades,
  adminEnumRoutes.socialPlatform,
  adminEnumRoutes.events,
  adminEnumRoutes.transactions,
  adminEnumRoutes.refunds,
  adminEnumRoutes.transferToBankRequest,
  adminEnumRoutes.announcements,
  adminEnumRoutes.newsLetters,
  adminEnumRoutes.articles,
  adminEnumRoutes.wallets,
  adminEnumRoutes.conversionRate,
  adminEnumRoutes.issuedCertificates,
  adminEnumRoutes.assessments,
  adminEnumRoutes.permissions,
  adminEnumRoutes.supportTickets,
  adminEnumRoutes.organizationOverview,
];
